import API from 'services/api.js';
import { URL_GET_SESSION_IDS } from 'services/urls.js'
import { actionSetMessage, actionResetMessages } from 'components/messages/actions.js'

export const SET_SESSION = 'SET_SESSION';
export const SET_SESSION_IDS = 'SET_SESSION_IDS'
export const RESET_SESSION_IDS = 'RESET_SESSION_IDS'

// Sync Action

export const actionSetSession = (data) => {
	//console.log('data',data)
	return {
		type: SET_SESSION,
		data
	}
}

export const actionFetchSessionIds = (clientId, setSessionLoading) => {
	//console.log('actionFetchSessionIds()')
	return (dispatch) => {
		dispatch(actionResetMessages())
		const params = {
			params: {clientId: clientId,},
		}
		//console.log('URL_GET_SESSION_IDS', URL_GET_SESSION_IDS)
		//console.log('params', params)
		var resp = null
		return API.get(URL_GET_SESSION_IDS, params)
		.then(response => {
			//console.log('response.data', response.data)
			// try{
			// 	resp = response.data
			// 	//console.log('response.data.length', response.data.length)
			// } catch (error){}
				resp = response.data
			}
		)
		.catch(error => {
			console.log('error', error)
			dispatch(actionSetMessage('Error fetching Session ID\'s: ' + error))
			resp = []
		}).then(() => {
			dispatch(actionFetchSessionIdsSuccess(resp))
			setSessionLoading(false)
		});
	};
};

export const actionFetchSessionIdsSuccess = (data) => {
	return {
		type: SET_SESSION_IDS,
		data
	}
}

export const actionResetSessionIds = () => {
	return {type: RESET_SESSION_IDS,}
}